import { createFileRoute } from '@tanstack/react-router'

import { NewLineItemPage } from '@/pages/line-items/new/NewLineItemPage'

export const Route = createFileRoute('/_authenticated/_dashboard/line-items/new/')({
  component: NewLineItemPage,
})
